import { createApp, type App } from 'vue';
import PageSubnav from './PageSubnav.vue';
import { subnavByNamespace, type SubnavConfig } from './subnav-config';

const MOUNT_ID = 'subnav-vue';

let subnavApp: App | null = null;

function getMountEl(): HTMLElement | null {
  return document.getElementById(MOUNT_ID);
}

/**
 * Смонтировать или очистить Vue-подменю в #subnav-vue.
 * Один инстанс на страницу; при смене Barba снимаем старый, чтобы пусто на страницах без subnav.
 */
export function mountPageSubnav(config: SubnavConfig | null): void {
  const el = getMountEl();
  if (!el) return;

  if (subnavApp) {
    subnavApp.unmount();
    subnavApp = null;
  }
  el.innerHTML = '';

  if (!config?.items?.length) return;

  const app = createApp(PageSubnav, { ...config });
  subnavApp = app;
  app.mount(el);
}

/**
 * Синхронизировать subnav с текущим Barba-namespace (и с первой отрисовкой).
 */
export function applySubnavForNamespace(namespace: string | undefined): void {
  if (!namespace) {
    mountPageSubnav(null);
    return;
  }
  const config = subnavByNamespace[namespace];
  if (!config) {
    mountPageSubnav(null);
    return;
  }
  mountPageSubnav(config);
}
